// Implements: F-UIX-009, F-UIX-010
/**
 * The device list, under its own query key, `["auth","sessions"]` (design section 4).
 *
 * The hook returns the query itself rather than a hand-rolled triple of
 * `loading | data | error`: the container needs all three plus a retry, and
 * re-wrapping them here would be a second state machine that can disagree with
 * the first one. What the hook DOES own is the key and the fetcher, so the
 * revocation path knows exactly what to invalidate.
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { AUTH_SESSIONS_KEY } from "../../../shared/api/queryKeys";
import type { SessionSummary } from "../../../types/api";
import { fetchSessions } from "../api/authApi";

export type UseSessionsResult = UseQueryResult<readonly SessionSummary[], ApiError>;

export function useSessions(): UseSessionsResult {
  return useQuery<readonly SessionSummary[], ApiError>({
    queryKey: AUTH_SESSIONS_KEY,
    queryFn: fetchSessions,
  });
}
